import axios from "axios";
import { Constants } from "../utils/Constants";

// Página pública da proposta: sem login, o token do link é a credencial.
const base = `${Constants.url}/api/public/propostas`;

export function getProposal(token) {
    return axios.get(`${base}/${token}`);
}

export function proposalPdfUrl(token) {
    return `${base}/${token}/pdf`;
}

export function respondProposal(token, form) {
    return axios.post(`${base}/${token}/resposta`, form);
}
